// Welke fundering hoort bij een configuratie? (TPLA-625)
//
// Per model staat in het CMS welke funderingstypes gekozen mogen worden
// (availableOptions.funderingTypes) en welke daarvan de standaard is
// (availableOptions.funderingTypeDefault). De configurator moet altijd op een
// type staan dat bij het model hoort: anders is in het Opties-tabblad niets
// geselecteerd en gaat het verkeerde artikel-keyword naar DriveWorks.
//
//   types     - alle funderingstypes (getFunderingTypesPublic)
//   model     - het model uit getModelTypes; mag ontbreken
//   currentId - het type waar de configuratie nu op staat; mag ontbreken
//   chosen    - true als currentId een keuze van de klant is (aangeklikt, of
//               uit een opgeslagen configuratie) en niet zelf een standaard

// Zelfde ondergrond = zelfde poeren- en vloerinstelling. Zo vinden "zand" en
// "zand met schuifanker" elkaar zonder dat de types naar elkaar verwijzen.
function sameGround (a, b) {
  return Boolean(a.poerenEnabled) === Boolean(b.poerenEnabled) &&
    Boolean(a.vloerEnabled) === Boolean(b.vloerEnabled)
}

export function resolveFunderingType ({ types, model, currentId, chosen = false }) {
  const all = types || []
  const current = all.find((t) => t.id === currentId)
  const globalDefault = all.find((t) => t.isDefault)

  const allowedIds = model?.availableOptions?.funderingTypes || []
  const allowed = all.filter((t) => allowedIds.includes(t.id))

  // Model zonder eigen lijst: het gedrag van voor TPLA-625.
  if (!allowed.length) return current || globalDefault || null

  if (chosen && current) {
    if (allowed.includes(current)) return current
    const counterpart = allowed.find((t) => sameGround(t, current))
    if (counterpart) return counterpart
  }

  const modelDefault = allowed.find((t) => t.id === model.availableOptions.funderingTypeDefault)
  if (modelDefault) return modelDefault

  if (globalDefault) {
    if (allowed.includes(globalDefault)) return globalDefault
    const counterpart = allowed.find((t) => sameGround(t, globalDefault))
    if (counterpart) return counterpart
  }

  return allowed[0]
}
